import AnimatedCounter from "@/components/shared/AnimatedCounter";
import { ScrollReveal, StaggerParent, StaggerItem } from "@/components/shared/ScrollReveal";
import { useLang } from "@/i18n/LanguageContext";

const EXTRA = [
  { end: 220, suffix: "+", label: { it: "Contenuti pubblicati / settimana", en: "Content published / week" } },
  { end: 4, suffix: "", label: { it: "Canali video Modo", en: "Modo video channels" } },
  { end: 40, suffix: "+", label: { it: "Progetti speciali / anno", en: "Special projects / year" } },
  { end: 20, suffix: "+", label: { it: "Eventi realizzati", en: "Events delivered" } },
];

export default function Numbers() {
  const { t, lang } = useLang();
  const total = String(t.kpis.length + EXTRA.length).padStart(2, "0");
  return (
    <section
      id="numeri"
      data-testid="numbers-section"
      className="relative bg-black text-white py-28 md:py-40 border-t border-white/10 overflow-hidden scroll-mt-20"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <ScrollReveal>
          <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-6">{t.numbers.eyebrow}</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight mb-20 max-w-3xl">
            {t.numbers.title}
          </h2>
        </ScrollReveal>

        <StaggerParent className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.kpis.map((k, i) => (
            <StaggerItem key={i}>
              <div
                data-testid={`num-tile-${i}`}
                className="tile-card p-8 md:p-10 h-52 md:h-64 flex flex-col justify-between"
              >
                <p className="font-mono-eyebrow text-neutral-500">
                  {String(i + 1).padStart(2, "0")} / {total}
                </p>
                <div>
                  <div className="mega-num text-white text-[72px] md:text-[110px] lg:text-[128px] mb-3">
                    <AnimatedCounter end={k.value} suffix={k.suffix} format={(n) => n.toString()} />
                  </div>
                  <p className="text-neutral-400 text-sm md:text-base max-w-[220px] leading-snug">
                    {k.label}
                  </p>
                </div>
              </div>
            </StaggerItem>
          ))}
          {EXTRA.map((k, i) => (
            <StaggerItem key={`extra-${i}`}>
              <div
                data-testid={`num-tile-extra-${i}`}
                className="tile-card p-8 md:p-10 h-52 md:h-64 flex flex-col justify-between"
              >
                <p className="font-mono-eyebrow text-neutral-500">
                  {String(t.kpis.length + i + 1).padStart(2, "0")} / {total}
                </p>
                <div>
                  <div className="mega-num text-white text-[72px] md:text-[110px] lg:text-[128px] mb-3">
                    <AnimatedCounter end={k.end} suffix={k.suffix} format={(n) => n.toString()} />
                  </div>
                  <p className="text-neutral-400 text-sm md:text-base max-w-[220px] leading-snug">
                    {k.label[lang]}
                  </p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerParent>
      </div>
    </section>
  );
}
